import React from 'react';
import { withSessionSsr, getPublicToken } from "../../lib/sessionMiddleware";
import { getCanonicalPath } from "../../lib/canonical";
import useHook from '../../hooks/pages/inspo/useHook';
import styles from './styles.module.scss';
import {
  Navbar,
  Wrapper,
  TituloSeccion,
  SubtituloSeccion,
  Seccion,
  Footer,
  Loader,
  HeadTags,
  BtnFlotanteWhatsapp,
  ItemNota,
  CarouselDeBanners,
  Container,
}from '../../components';

import {
  Button,
  useTheme,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,   
  Stack,
  Pagination, 
} from '@mui/material';


const BlogPage = (props)=>{

  const notas = props.pageProps.notas;
  const tipos = props.pageProps.tipos;
  const tematicas = props.pageProps.tematicas;

  const theme = useTheme();

  const {
    mobile,
    tipo,
    handleTipo,
    tematica,
    handleTematica,
    notasHydratated,
    totalPages,
    page,
    setPage,
  } = useHook({notas});
    
  return(<>

    <HeadTags  
      title="Inspo" 
      description="Inspirate con nuestro contenido"
      path={props.pageProps.pathname}
    />

    <Navbar/>

    <Seccion padding="40px 20px" paddingMobile="20px">
      <Wrapper>             
        <TituloSeccion align="center">Inspo</TituloSeccion>
        <br/>
        <SubtituloSeccion align="center">Inspirate con nuestro contenido</SubtituloSeccion>
        <br/><br/>
        <Container width="600px">
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <FormControl fullWidth>
                <InputLabel id="tipos">Notas por tipo de producto</InputLabel>
                <Select
                  labelId="tipos"
                  id="tipos"
                  value={tipo || ' '}
                  label="Notas por tipo de producto"
                  onChange={(e)=>handleTipo(e.target.value)}
                  color="secondary"
                >
                  <MenuItem value=" ">Todos</MenuItem>
                  {tipos?.map(item=>(
                    <MenuItem value={item.attributes?.slug} key={item.id}>{item.attributes?.nombre}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>   
            <Grid item xs={12} md={6}>
              <FormControl fullWidth>
                <InputLabel id="tematicas">Notas por temática</InputLabel>
                <Select
                  labelId="tematicas"
                  id="tematicas"
                  value={tematica || " "}
                  label="Notas por temática"
                  onChange={(e)=>handleTematica(e.target.value)}
                  color="secondary"
                >
                  <MenuItem value=" ">Todas</MenuItem>
                  {tematicas?.map(item=>(
                    <MenuItem value={item.attributes?.slug} key={item.id}>{item.attributes?.nombre}</MenuItem>
                  ))}
                </Select>
              </FormControl>                                
            </Grid>   
          </Grid>
        </Container>
        <br/><br/>
        <div className={styles.contenedor}>
          {notasHydratated?.map(item=>(
            <ItemNota data={item} key={item.id} />
          ))}
          {notasHydratated.length == 0 &&
                        <p>Sin notas para los filtros seleccionados.</p>
          }

        </div>
        <br/><br/><br/>
        {totalPages > 0 &&
                    <Stack spacing={2} style={{ display: 'flex', alignItems: 'center' }}>
                      <Pagination
                        count={totalPages}
                        defaultPage={page}
                        siblingCount={1}
                        onChange={(e, newValue) => setPage(newValue)}
                      />
                    </Stack>
        }                

      </Wrapper>
    </Seccion>

    <br/><br/><br/>
        
    <Footer/>
 
    <BtnFlotanteWhatsapp/>
  </>);
};

export default BlogPage;

export const getServerSideProps = withSessionSsr(
  async function getServerSideProps(ctx) {
  
    const { req } = ctx;
        
    const publicToken = await getPublicToken(req);
    const fetchNotas = async()=>{
      let body={
        page: 1,
        pageSize: 10,
        sort: "score%3Adesc",
      };
      try{
        const result = await fetch(`${process.env.NEXT_PUBLIC_URL_FRONTEND}/api/notas/get-filtered`, {
          method: 'POST',
          headers: { 
            'Content-Type': 'application/json',
            'x-spiral-secret': process.env.SPIRAL_SECRET
          },
          body: JSON.stringify(body)
        });
        let data = await result.json();
        // console.log("notas", data.data)
        return (data?.data || []);
      }catch(err){
        console.log("e", err);
        return [];
      }  
    }; 

    const fetchTipos = async()=>{
      try{
        const result = await fetch(`${process.env.NEXT_PUBLIC_URL_FRONTEND}/api/tipos/get-filtered`, {
          method: 'POST',
          headers: { 
            'Content-Type': 'application/json',
            'x-spiral-secret': process.env.SPIRAL_SECRET
          },
        });
        let data = await result.json();
        // console.log("tipos", data.data)
        return (data?.data || []);
      }catch(err){
        console.log("e", err);
        return [];
      }  
    }; 
        
    const fetchTematicas = async()=>{
      try{
        const result = await fetch(`${process.env.NEXT_PUBLIC_URL_FRONTEND}/api/tematicas/get-filtered`, {
          method: 'POST',
          headers: { 
            'Content-Type': 'application/json',
            'x-spiral-secret': process.env.SPIRAL_SECRET
          },
        });
        let data = await result.json();
        // console.log("tematicas", data.data)
        return (data?.data || []);
      }catch(err){
        console.log("e", err);
        return [];
      }  
    }; 

    let notas = await fetchNotas();
    let tematicas = await fetchTematicas();
    let tipos = await fetchTipos();

    return {
      props: {
        pathname: getCanonicalPath(req),
        notas: notas,
        tematicas: tematicas,
        tipos: tipos,
      },
    };    
  
  },
);